<div class="flex flex-col items-center gap-4 p-4">
  <h3>Select a Partner</h3>
  <mat-form-field class="w-80">
    <input
      matInput
      placeholder="Search Partners"
      [formControl]="searchCtrl"
      [matAutocomplete]="auto"
      (keyup.enter)="selectFirstOption()"
    />
    <mat-autocomplete #auto="matAutocomplete">
      @for (
        workspace of workspaceSearch.results$ | async;
        track workspace.uid
      ) {
        <mat-option [value]="workspace" (click)="selectWorkspace(workspace)">{{
          workspace.workspace
        }}</mat-option>
      }
    </mat-autocomplete>
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
</div>
